import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ExamAttempt from './routes/ExamAttempt';

const LazyStudentExamDetails = React.lazy(
	() => import(/* webpackChunkName: 'StudentExamDetails' */ './components')
);

export default () => {
	return [
		{
			path: 'exam/:examConfigId',
			element: <AsyncLoading component={<LazyStudentExamDetails />} />,
		},
		ExamAttempt(),
	];
};
